import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import _ from "lodash";

import {TEXT} from "../../utilities/strings";

/**
 * Component to render select (dropdown) form elements
 *
 * @Example
 *  <FormSelect
 *    value={this.props.value}
 *    label={this.props.label}
 *    formId={this.props.formId}
 *    formName={this.props.formName}
 *    onChange={this.props.onChange}
 *  >;
 *     -OPTIONS-
 *  </FormSelect>;
 */
export default class FormSelect extends PureComponent {

  static propTypes = {
    children: PropTypes.node,
    noneOption: PropTypes.bool,
    disabled: PropTypes.bool,
    size: PropTypes.string,
    value: PropTypes.any,
    formId: PropTypes.string.isRequired,
    formName: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
  };

  static defaultProps = {
    size: 'sm'
  };

  handleChange = (event) => {
    this.props.onChange(event.target.value);
  };

  renderOptions = () => {
    if (this.props.noneOption) {
      return _.concat(<option key="" value="">{TEXT.form_none}</option>, this.props.children);
    } else {
      return this.props.children
    }
  };

  render() {
    return (
      <Form.Group as={Form.Row} controlId={`${this.props.formName} ${this.props.formId}`}>

        <Form.Label column={this.props.size} md={6} lg={6} xl={5}>
          {this.props.label}
        </Form.Label>

        <Col>
          <Form.Control
            as="select"
            disabled={this.props.disabled}
            value={this.props.value}
            onChange={this.handleChange}
            size={this.props.size}
            children={this.renderOptions()}
          />
        </Col>

      </Form.Group>
    );
  }
}
